export function Stomach() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1543 0C10.1543 5.5601 10.7348 7.00962 11.7697 8.25C11.7697 5.6899 13.0605 4.3738 13.0389 4.26923C12.9307 3.72115 12.8947 1.66587 12.8947 0H10.1543ZM18.0005 3.69231C15.0329 3.69231 12.9235 4.73798 12.9235 10.1538C12.9235 10.7488 13.2661 17.5385 9.31776 17.5385C6.38627 17.5385 6.31415 16.6154 4.12545 16.6154C3.18435 16.6154 2.26487 17.0337 1.38507 18.5481C0.822566 19.5144 0.0292969 21.7788 0.0292969 21.7788C0.0292969 21.7788 0.681941 23.0769 2.62545 22.7308C2.72641 22.363 3.14468 20.25 4.12545 20.25C4.92233 20.25 5.41632 20.2788 6.57737 21.3462C7.99444 22.6514 9.4079 23.8558 12.462 23.8558C17.4235 23.8558 22.2733 20.7079 23.5966 14.4519C25.2192 6.76803 20.968 3.69231 18.0005 3.69231Z"
        fill="#D0D3DC"
      />
    </svg>
  );
}
